// extracted by mini-css-extract-plugin
module.exports = {"root":"FinlandLayout-module--root--Buq9J","navigation":"FinlandLayout-module--navigation--2EK2U","content":"FinlandLayout-module--content--O5Rcu"};